<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model
      ref="form"
      :model="form"
      :rules="rules"
    >
        <a-form-model-item
          label="位置描述"
          prop="locationDescription"
        >
          <a-input
            v-model="form.locationDescription"
            placeholder="请输入位置描述"
            :maxLength="200"
          />
        </a-form-model-item>
    <div class="bottom-control">
      <a-space>
        <a-button
          type="primary"
          :loading="submitLoading"
          @click="submitForm"
        >
          保存
        </a-button>
        <a-button
          type="dashed"
          @click="cancel"
        >
          取消
        </a-button>
      </a-space>
    </div>
  </a-form-model>
</a-drawer>
</template>

<script>
import { deviceDataBatchAddressEdit } from '@/api/saifuneng/devicedata'

export default {
  name: 'AddressForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        idList: [],
        locationDescription: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        locationDescription: [
          { required: true, message: '位置描述不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        idList: [],
        locationDescription: null
      }
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
    },
    /** 编辑 */
    handleAddress(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '编辑'
      this.deviceList = row
      row.forEach(item => {
        this.form.idList.push(item.id)
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          deviceDataBatchAddressEdit(this.form).then(response => {
            this.$message.success(
              '编辑成功',
              3
            )
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    }
  }
}
</script>
